import "./palette-image-view";

import AbstractPaletteImageView from "./abstract-palette-image-view";

class PaletteImageView extends AbstractPaletteImageView {
	public static readonly tagName = "wf-debug-palette-image-view";
}
export default PaletteImageView;
